export default __webpack_public_path__ + "assets/webgl/scene-16.0c19ce95.glb";